<template>
  <base-dialog-no-button
    v-if="confirmationProcessing"
    title="Booking confirmation is being processed..."
  >
    <template #default>
      <div class="d-flex justify-content-center align-items-center">
        <img
        class="logo"
        src="@/assets/loader.gif"
        width="100"
      />
      <p class="m-0">{{ waitingMessage }}</p>
      </div>
    </template>
  </base-dialog-no-button>

  <base-card v-if="!hasRunSteps">
    <h3>Booking Instruction:</h3>
    <div>
      <h4>Hi there</h4>
      <span
        >Please follow the <b>STEPS</b> to complete the booking process
      </span>
      <p>
        <b>1.</b> SEARCH -> <b>2.</b>DETAILS -> <b>3.</b>PAYMENT ->
        <b>4.</b> CONFIRMATION
      </p>
    </div>
    <br />

    <base-button class="startbooking" @click="onClickStartBooking"
      >Start Booking Now
    </base-button>
  </base-card>

  <base-card v-else-if="paid">
    <h3 class="pintext">Thank you!</h3>
    <div class="final-message">
      <div>
        <h4>Your Payment Summary :</h4>
        <p>
          Booking fee : <b>${{ chargeAmount }}</b>
        </p>
        <p>
          Card Surcharge : <b>${{ surchargeAmount }}</b>
        </p>
        <p>
          Amount Payable : <b>${{ TotalAmount }}</b>
        </p>
        <p>
          Receipt Number : <b>{{ ReceiptNumber }}</b>
        </p>
      </div>
      <br />
      <div>
        <h4>Your Booking Summary :</h4>
        <p>
          Your Booking Confirmation Number : <b>{{ eventNumber }}</b>
        </p>
      </div>
    </div>
    <br />

    <div class="pintext">
      <h4>
        ------------------------------------------------------------------
      </h4>
      <p>
        Confirmation email and text including <b>PIN</b> to unlock door(s) has
        been sent to the details you have provided.
      </p>

      <h4>
        ------------------------------------------------------------------
      </h4>
    </div>
    <br />
  </base-card>

  <base-card v-else-if="paid === false">
    <p>
      Your payment failed with the following reason:
      <b>{{ paymentFailMessage }}</b>
      Booking failed, please contact your card issuer.
    </p></base-card
  >
</template>
<script>
import { recordBooking, fcctoken } from '../../../../config'; //

export default {
  props: ['solutions', 'eventid'],
  inject: ['setSelectedTag', 'resetPrevData'],
  emits: ['resetSession'],
  data() {
    return {
      confirmationProcessing: false,
      hasRunSteps: false,
      waitingMessage:
        "Please don't close the windows whilst booking confirmation is being processed...",
      paymentFailMessage: 'INCOMPLETE',
      paid: false,
      chargeAmount: null,
      surchargeAmount: null,
      TotalAmount: null,
      ReceiptNumber: null,
      paymentSolutions: null,
      bookingconfirmdetails: null,
      eventNumber: null,
      user: null,
      currentHost: null,
      currentEnv: null,
      failCount: 0,
    };
  },

  watch: {
    currentEnv() {
      // console.log('current Env', this.currentEnv);
    },

    paid() {
      if (this.paid) {
        // this.createUserInC4();
        this.confirmationProcessing = true;
        this.sendBooking();
      }
    },
  },

  methods: {
    // TODO, we need to handle when internet suddenly off at this time, local storage maybe needed.
    sendBooking() {
      var myHeaders = new Headers();
      myHeaders.append('Authorization', fcctoken);
      myHeaders.append('Content-Type', 'application/json');

      // M.A 29/11/2022 - Changing the time for EndTime/EndDate to match the 00 time from 59 (for database/C4)      
      var roundedTime = this.solutions.originalBookingReq.EndDate;
      let selectedVenueUpdate = Object.assign({}, this.solutions.selectedVenue);
      selectedVenueUpdate.EndDate = roundedTime;
      selectedVenueUpdate.EndTime = roundedTime;      

      var prepBook = {
        EventNumber: this.eventNumber,
        CurrentBookingDetails: {
          Contact: this.solutions.user,
          SelectedVenueDetails: selectedVenueUpdate,
          CurrentBooking: this.solutions.originalBookingReq,
          CurrentEvent: this.solutions.bookingconfirmdetails.result,
          AdditionalRequirements: this.solutions.additionalRequirements,
        },
        Payment: this.solutions.payment[0],
      };

      // console.log('this full booking ', prepBook);

      var raw = JSON.stringify(prepBook);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
      };
      var url = this.currentEnv.gateway + recordBooking + this.eventNumber;
      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((resp) => {
          //  console.log('event number', this.eventNumber, resp.EventNumber);
          this.eventNumber = resp.EventNumber;

          this.confirmationProcessing = false;
          setTimeout(() => {
            window.location.reload();
          }, 120000);
          return this.eventNumber;
        })
        .catch((error) => {
          // TODO this is the place to call different API, which trigger another email about the error
          if (this.failCount < 10) {
            setTimeout(() => {
              this.sendBooking();
            }, 5000);
            this.failCount += 1;
          } else {
            this.waitingMessage =
              'Look like your internet connection has problem, booking incomplete, please contact us booking number :' +
              this.eventNumber;
          }

          console.log('error', error);
        });
    },

    onClickStartBooking() {
      this.user = [];
      this.$eventBus.emit('resetSession', null);
    },
  },

  beforeMount() {
    this.currentHost = location.host;
    // console.log(' current host in summary', location.host);
  },

  mounted() {
    if (this.solutions.user !== null) {
      this.user = this.solutions.user;
      this.hasRunSteps = true;
      this.currentEnv = this.solutions.env;
      //  console.log('booking info', this.solutions);
    }

  //  console.log('bookingsummary page ', this.solutions);
    if (this.solutions.payment !== null) {
      this.hasRunSteps = true;
      let payment = this.solutions.payment[0];
      if (payment['TxnResp']['ResponseText'] === 'Approved') {
        this.paid = true;
        this.TotalAmount = (payment['TxnResp'].Amount / 100).toFixed(2);
        this.surchargeAmount = (
          payment['TxnResp'].AmountSurcharge / 100
        ).toFixed(2);
        this.chargeAmount = (payment['TxnResp'].AmountOriginal / 100).toFixed(
          2
        );
        this.ReceiptNumber = payment['TxnResp'].ReceiptNumber;

        if (this.solutions.bookingconfirmdetails !== null) {
          this.user = this.solutions.user;
          this.bookingconfirmdetails = this.solutions.bookingconfirmdetails;
          this.eventNumber = this.bookingconfirmdetails.result.EventNumber;

          //  console.log(' booking here ');
        }
      } else {
        this.paymentFailMessage = payment['TxnResp']['ResponseText'];
      }
    }
  },
};
</script>

<style scoped>
p.summaryWait {
  font-weight: bolder;
  position: relative;
  word-wrap: break-word;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #3a0061;
  background-color: #f7ebff;
}

.final-message {
  margin-left: 2rem;
}

.pintext {
  text-align: center;

  margin-right: 6rem;
  margin-left: 6rem;
}

.pin {
  font-weight: 500;
}
</style>
